import React from 'react'
import cn from 'classnames'

import styles from './Box.module.css'

interface BoxProps {
  header?: React.ReactNode
  big?: boolean
  style?: {
    [key: string]: string
  }
}

const Box: React.FC<BoxProps> = ({ header, children, big = false, style }) => (
  <div style={style} className={styles.box}>
    {header && <header className={styles.header}>{header}</header>}
    <div
      className={cn(styles.boxInner, {
        [styles.boxInnerBig]: big,
      })}
    >
      {children}
    </div>
  </div>
)

export default Box
